import React from 'react'
import ReactDOM from 'react-dom'

import { BrowserRouter } from 'react-router-dom'

import { ThemeProvider } from '@driftt/dds'
import LoadStyles from '@driftt/tide-core/dist/styles'
import ConnectedApp from '@driftt/traffic-control'

import config from './config'
import App from './layouts/App'

LoadStyles()

ReactDOM.render(
  <ConnectedApp
    render={() => (
      <ThemeProvider>
        <BrowserRouter basename="/meetings">
          <App />
        </BrowserRouter>
      </ThemeProvider>
    )}
    authClientId={config.AUTH_CLIENT_ID}
    sentryId={config.SENTRY_DSN}
    sentryConfig={{
      tracesSampleRate: 0.2,
      release: '20251219060910-c5ee0f1',
    }}
  />,
  document.getElementById('root')
)
